
export  default  function convertRapidocToOpenApi(rapidocJson) {
    const clean = {
        openapi: rapidocJson.openapi || "3.0.1",
        info: rapidocJson.info || {},
        servers: (rapidocJson.servers ?? []).map((s) => ({ url: s.url })),
        paths: {},
    };

    (rapidocJson.paths ?? []).forEach((p) => {
        if (!clean.paths[p.path]) clean.paths[p.path] = {};
        clean.paths[p.path][p.method] = {
            summary: p.summary || "",
            description: p.description || "",
            operationId: p.operationId,
            parameters: p.parameters || [],
            requestBody: p.requestBody || undefined,
            responses: p.responses || {},
        };
    });

    return clean;
};

export  function getOpenApiJsonAsString(detailsRoot, path) {
    const openApiFormat = {
        openapi: "3.0.1",
        info: {
            title: detailsRoot?.info?.title || "",
            version: detailsRoot?.info?.version || "",
        },
        servers: detailsRoot?.servers ?? [],
        paths: [path],
    };

    return JSON.stringify(convertRapidocToOpenApi(openApiFormat), null, 2);
}